// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__2danR","TopMain":"style_TopMain__2XCjp","Title":"style_Title__3eKUg","ScreenBody":"style_ScreenBody__2--Bw","StoreList":"style_StoreList__3D6Ff"};